import React, { Component } from "react";
import { Grid, Container } from "semantic-ui-react";
import { OverdueLoansList, RenewedLoansList } from "./lists";
import { DocumentCard, LoansCard } from "./widgets";
import { authenticationService } from "@authentication/services/AuthenticationService";
import { sessionManager } from "@authentication/services/SessionManager";
import AdminHome from "@components/backoffice/Sidebar/AdminHome";

const cardStyle = {
  transform: "translateY(0)",
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
};

const sectionStyle = {
  background: "linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)",
  borderRadius: "16px",
  padding: "2rem",
  boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08)",
  border: "1px solid rgba(255, 255, 255, 0.6)",
  marginBottom: "1.5rem",
};

export default class Home extends Component {
  render() {
    const user = sessionManager.user || {};

    if (!user || !user.roles) {
      return (
        <Container
          fluid
          style={{ maxWidth: "100%", textAlign: "center", padding: "2rem" }}
        >
          <div>Loading user data...</div>
        </Container>
      );
    }

    const isAdmin = authenticationService.hasRoles(user, ["admin"]);

    if (isAdmin) {
      return <AdminHome user={user} />;
    }

    const cards = [
      { key: "loans", Component: LoansCard },
      { key: "docs", Component: DocumentCard },
    ];

    const sections = [
      {
        key: "overdue",
        title: "Overdue Loans",
        color: "#667eea",
        Content: OverdueLoansList,
      },
      {
        key: "renewed",
        title: "Renewed Loans",
        color: "#48bb78",
        Content: RenewedLoansList,
      },
    ];

    return (
      <Container fluid style={{ maxWidth: "100%" }}>
        <div
          style={{
            background: "rgba(255, 255, 255, 0.95)",
            backdropFilter: "blur(10px)",
            borderRadius: "20px",
            padding: "2rem",
            boxShadow: "0 20px 40px rgba(0, 0, 0, 0.1)",
            border: "1px solid rgba(255, 255, 255, 0.2)",
          }}
        >
          <Grid stackable style={{ width: "100%", margin: 0 }}>
            <Grid.Row columns={2}>
              {cards.map(({ key, Component }) => (
                <Grid.Column key={key} style={{ padding: "0.5rem" }}>
                  <div style={cardStyle}>
                    <Component />
                  </div>
                </Grid.Column>
              ))}
            </Grid.Row>

            <Grid.Row columns={1}>
              <Grid.Column style={{ padding: "0.5rem" }}>
                {sections.map(({ key, title, color, Content }) => (
                  <div key={key} style={sectionStyle}>
                    <Content />
                  </div>
                ))}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </Container>
    );
  }
}
